export default {
  groups: {
    height: '100%',
    flex: '1',
    overflow: 'auto',
    padding: '0 20px'
  },
  categories: {
    width: '150px',
    flexShrink: '0',
    borderRight: '1px solid #ececec',
    overflow: 'auto',
    '@media (max-width: 450px)': {
      display: 'none'
    }
  },
  wrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    backgroundColor: '#fff'
  }
}
